import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const MgidTracker = () => {
    const location = useLocation();

    useEffect(() => {
        if (window._mgq) {
            window._mgq.push(["MgSensorInvoke", "Application"]);
            console.log("MGID triggered on:", location.pathname);
        }
    }, [location.pathname]);

    return null;
};

export default MgidTracker;
